/**
 * Clovie - eigene Warenkorb-Erweiterungen (Ersatz fuer UpCart)
 * Banner-Inhalt (Bild/Texte) wird in doc-head-core.liquid ueber window.CLOVIE_BANNER gesetzt.
 *
 * Funktionen:
 *  1) Snocks-Style Banner unter dem Titel (Headline + Subtext + Bild rechts)
 *  2) "Spare EUR X" pro Position
 *  3) "Clovie Garantie" Add-on-Toggle (gestaffelt)
 *  4) Kompakterer Footer + kleinere Empfehlungs-Kacheln (CSS)
 *
 * Versandkostenfrei-Balken laeuft ueber die native Theme-Einstellung.
 * Hinweis: Das Garantie-Produkt muss "Bestand nicht verfolgen" haben.
 */
(function () {
  'use strict';

  var WARRANTY = {
    productId: 9393296834902,
    tiers: [
      { max: 5000, variant: 49607610728790, price: 99 },
      { max: 8000, variant: 49607638679894, price: 199 },
      { max: 12000, variant: 49607638745430, price: 299 },
      { max: 16000, variant: 49607638810966, price: 399 },
      { max: Infinity, variant: 49607638909270, price: 499 }
    ],
    title: 'Clovie Garantie - 6 Monate extra Schutz!',
    blurb: 'Erweiterter Schutz fuer deine Bestellung'
  };
  var WARRANTY_VARIANTS = WARRANTY.tiers.map(function (t) { return t.variant; });

  var CFG = (typeof window !== 'undefined' && window.CLOVIE_BANNER) || {};
  var BANNER = {
    title: CFG.title || 'Du hast verdammt guten Geschmack.',
    sub: CFG.sub || 'Dein Warenkorb kann sich sehen lassen.',
    img: CFG.img || ''
  };

  var syncing = false;

  function fmtEuro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function parseMoney(str) {
    if (!str) return null;
    var s = String(str).replace(/[^0-9.,]/g, '').trim();
    if (!s) return null;
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  /* ---------- 1) Snocks-Style Banner (unter dem Titel) ---------- */
  function injectBanner() {
    var upper = document.querySelector('.js-cart-drawer .cart-drawer__content-upper');
    if (!upper) return;
    var hasItems = document.querySelector('.js-cart-drawer .cart-item');
    var existing = upper.querySelector('.clovie-banner');
    if (!hasItems) { if (existing) existing.remove(); return; }
    if (existing) return;
    var el = document.createElement('div');
    el.className = 'clovie-banner';
    var img = BANNER.img ? '<div class="clovie-banner__img" style="background-image:url(\'' + BANNER.img + '\')"></div>' : '';
    el.innerHTML =
      '<div class="clovie-banner__text">' +
        '<div class="clovie-banner__title">' + BANNER.title + '</div>' +
        '<div class="clovie-banner__sub">' + BANNER.sub + '</div>' +
      '</div>' + img;
    var header = upper.querySelector('.cart-drawer__header');
    if (header) {
      header.insertAdjacentElement('afterend', el);
    } else {
      upper.insertBefore(el, upper.firstChild);
    }
  }

  /* ---------- 2) "Spare EUR X" pro Position ---------- */
  function injectLineSavings() {
    var items = document.querySelectorAll('.js-cart-drawer .cart-item');
    items.forEach(function (item) {
      try {
        var priceCol = item.querySelector('.cart-item__price');
        if (!priceCol) return;
        var sellingEl = priceCol.querySelector('.cart-item__selling-price');
        var struckEl = priceCol.querySelector('.struck-out-price');
        var existing = item.querySelector('.clovie-line-savings');
        if (!sellingEl || !struckEl) { if (existing) existing.remove(); return; }
        var sell = parseMoney(sellingEl.textContent);
        var was = parseMoney(struckEl.textContent);
        var qtyInput = item.querySelector('.cart-item__quantity-input');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (sell == null || was == null || was <= sell) { if (existing) existing.remove(); return; }
        var savings = (was - sell) * qty;
        if (!existing) {
          existing = document.createElement('div');
          existing.className = 'clovie-line-savings';
          priceCol.appendChild(existing);
        }
        existing.textContent = 'Spare ' + fmtEuro(savings);
      } catch (e) {}
    });
  }

  /* ---------- 3) Garantie-Add-on ---------- */
  function tierFor(subtotal) {
    for (var i = 0; i < WARRANTY.tiers.length; i++) {
      if (subtotal < WARRANTY.tiers[i].max) return WARRANTY.tiers[i];
    }
    return WARRANTY.tiers[WARRANTY.tiers.length - 1];
  }

  function findWarrantyLine(cart) {
    return cart.items.filter(function (i) {
      return i.product_id === WARRANTY.productId || WARRANTY_VARIANTS.indexOf(i.variant_id) > -1;
    })[0];
  }

  function subtotalExclWarranty(cart) {
    var total = 0;
    cart.items.forEach(function (i) {
      if (i.product_id !== WARRANTY.productId && WARRANTY_VARIANTS.indexOf(i.variant_id) === -1) {
        total += i.final_line_price;
      }
    });
    return total;
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_clovie_addon': 'garantie' } }] })
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function toggleWarranty(on) {
    if (syncing) return;
    syncing = true;
    getCart().then(function (cart) {
      var line = findWarrantyLine(cart);
      if (on && !line) {
        return addVariant(tierFor(subtotalExclWarranty(cart)).variant);
      } else if (!on && line) {
        return changeLine(line.key, 0);
      }
    }).then(function () {
      syncing = false; refreshDrawer();
    }).catch(function () { syncing = false; refreshDrawer(); });
  }

  function reconcileTier() {
    if (syncing) return;
    getCart().then(function (cart) {
      var line = findWarrantyLine(cart);
      if (!line) return;
      var correct = tierFor(subtotalExclWarranty(cart)).variant;
      if (line.variant_id !== correct) {
        syncing = true;
        changeLine(line.key, 0)
          .then(function () { return addVariant(correct); })
          .then(function () { syncing = false; refreshDrawer(); })
          .catch(function () { syncing = false; });
      }
    });
  }

  var SHIELD = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#1f9d57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"></path><path d="M9 12l2 2 4-4"></path></svg>';

  function injectWarrantyToggle(cart) {
    var checkoutBtns = document.querySelector('.js-cart-drawer .checkout-buttons');
    if (!checkoutBtns || !checkoutBtns.parentNode) return;
    try {
      var hasRealItems = cart.items.some(function (i) {
        return i.product_id !== WARRANTY.productId && WARRANTY_VARIANTS.indexOf(i.variant_id) === -1;
      });
      var existing = document.querySelector('.js-cart-drawer .clovie-warranty');
      if (!hasRealItems) { if (existing) existing.remove(); return; }
      var line = findWarrantyLine(cart);
      var tier = tierFor(subtotalExclWarranty(cart));
      if (!existing) {
        existing = document.createElement('div');
        existing.className = 'clovie-warranty';
        existing.innerHTML =
          '<div class="clovie-warranty__icon">' + SHIELD + '</div>' +
          '<div class="clovie-warranty__text"><span class="clovie-warranty__title"></span><span class="clovie-warranty__blurb"></span></div>' +
          '<label class="clovie-warranty__switch"><input type="checkbox" class="clovie-warranty__input"><span class="clovie-warranty__slider"></span></label>';
        checkoutBtns.parentNode.insertBefore(existing, checkoutBtns);
        existing.querySelector('.clovie-warranty__input').addEventListener('change', function (e) {
          toggleWarranty(e.target.checked);
        });
      }
      existing.querySelector('.clovie-warranty__title').textContent = WARRANTY.title + '  ' + fmtEuro(tier.price);
      existing.querySelector('.clovie-warranty__blurb').textContent = WARRANTY.blurb;
      existing.querySelector('.clovie-warranty__input').checked = !!line;
    } catch (e) {}
  }

  /* ---------- CSS ---------- */
  function injectCss() {
    if (document.getElementById('clovie-cart-css')) return;
    var css =
      '.clovie-banner{display:flex;align-items:stretch;background:#efece8;border-radius:10px;overflow:hidden;margin-bottom:14px;min-height:78px}' +
      '.clovie-banner__text{flex:1 1 auto;padding:14px 16px;display:flex;flex-direction:column;justify-content:center}' +
      '.clovie-banner__title{font-weight:700;font-size:1rem;color:#1a1a1a;line-height:1.2}' +
      '.clovie-banner__sub{font-size:.8rem;color:#5f5f5f;margin-top:3px}' +
      '.clovie-banner__img{flex:0 0 38%;background-size:contain;background-repeat:no-repeat;background-position:center bottom;min-height:78px}' +
      '.clovie-line-savings{color:#1f9d57;font-weight:700;font-size:.8rem;margin-top:2px;text-align:right}' +
      '.clovie-warranty{display:flex;align-items:center;gap:10px;padding:10px 12px;border:1px solid #e3e3e3;border-radius:10px;margin-bottom:12px}' +
      '.clovie-warranty__icon{flex:0 0 auto;display:flex;align-items:center}' +
      '.clovie-warranty__text{display:flex;flex-direction:column;line-height:1.25;flex:1 1 auto;min-width:0}' +
      '.clovie-warranty__title{font-weight:700;font-size:.82rem;color:#1a1a1a}' +
      '.clovie-warranty__blurb{font-size:.72rem;color:#6b6b6b}' +
      '.clovie-warranty__switch{position:relative;display:inline-block;width:44px;height:24px;flex:0 0 auto}' +
      '.clovie-warranty__input{opacity:0;width:0;height:0;position:absolute}' +
      '.clovie-warranty__slider{position:absolute;inset:0;background:#ccc;border-radius:24px;transition:.2s;cursor:pointer}' +
      '.clovie-warranty__slider::before{content:"";position:absolute;height:18px;width:18px;left:3px;top:3px;background:#fff;border-radius:50%;transition:.2s}' +
      '.clovie-warranty__input:checked + .clovie-warranty__slider{background:#1f9d57}' +
      '.clovie-warranty__input:checked + .clovie-warranty__slider::before{transform:translateX(20px)}' +
      '.js-cart-drawer .cart-drawer__footer{padding-top:10px}' +
      '.js-cart-drawer .subtotal{font-size:1.05rem;margin-bottom:2px}' +
      '.js-cart-drawer .cart-policies{font-size:.72rem;line-height:1.3}' +
      '.js-cart-drawer .cart-item-upsells{font-size:.85rem;margin-top:4px}' +
      '.js-cart-drawer .cart-item-upsells .product-block__title{font-size:.78rem;line-height:1.25}' +
      '.js-cart-drawer .cart-item-upsells .product-price{font-size:.8rem}' +
      '.js-cart-drawer .cart-item-upsells .image-cont{max-width:96px;margin-inline:auto}';
    var style = document.createElement('style');
    style.id = 'clovie-cart-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function enhance() {
    injectBanner();
    injectLineSavings();
    getCart().then(function (cart) {
      injectWarrantyToggle(cart);
    }).catch(function () {});
  }

  function init() {
    injectCss();
    enhance();
    document.addEventListener('on:cart:after-merge', function () { enhance(); reconcileTier(); });
    document.addEventListener('on:cart-drawer:after-open', enhance);
    document.addEventListener('on:cart:add', function () { enhance(); reconcileTier(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
